import React, { useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useField } from '@unform/core';

type TVTextFieldProps = TextFieldProps & {
  name: string;
  calcular?: (novoTextoselect: string | undefined) => void;
};

export const VTextFieldNumber: React.FC<TVTextFieldProps> = ({ calcular, name, ...rest }) => {
  const { fieldName, registerField, defaultValue, error, clearError } = useField(name);

  // `defaultValue` daqui vem do unform (dado inicial do formulário) — quase
  // sempre undefined pra esse campo, já que o valor inicial de verdade
  // costuma vir direto na prop do componente (ex.: `defaultValue={1}` no
  // Qtd. de parcelas do PDV). Sem cair também pra `rest.defaultValue`, o
  // campo sempre nascia vazio, só sendo preenchido depois se algum
  // setFieldValue explícito rodasse.
  const [value, setValue] = useState(defaultValue ?? (rest.defaultValue !== undefined ? String(rest.defaultValue) : ''));

  useEffect(() => {
    registerField({
      name: fieldName,
      getValue: () => value,
      setValue: (_, newValue) => setValue(newValue),
    });
  }, [registerField, fieldName, value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    calcular?.(e.target.value);

    // Verifica se o valor é numérico antes de atualizar o estado
    if (/^\d*\.?\d*$/.test(inputValue)) {
      setValue(inputValue);
      rest.onChange?.(e);
    }
  };
  return (
    <TextField
      {...rest}
      error={!!error}
      helperText={error}
      defaultValue={defaultValue}
      value={value}
      onChange={handleInputChange}
      onKeyDown={(e) => {
        error && clearError();
        rest.onKeyDown?.(e);
      }}
    />
  );
};
